import React from "react";
import Style from './Experience.module.scss';
import ExpBlock from "./ExpBlock";
import { info } from "../../info/info";
import { Box, Grid } from "@mui/material";

export function Experience() {
    let exp = info.experience.slice(0).reverse();
    function myExperience() {
        return <>
            <ul>
                {exp.map((work, index) =>
                    <Box className={Style.expBloc} key={index} backgroundColor={'transparent'}>
                        <li><Box className={Style.postname} component={'span'} mr={'1rem'}>{work.post}</Box></li>
                        <p style={{color: 'seagreen'}}>{work.company}</p>
                        <small className={Style.postdate}>{work.date}</small>
                        <ul className={Style.desco}>
                            {work.descrition.map((x) => (
                                <li key={String(x)}>{x}</li>
                            ))}
                        </ul>
                    </Box>
                )}
            </ul>
        </>;
    }
    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'}>
            <Grid container display={'flex'} justifyContent={'center'}>
                <ExpBlock text={myExperience()} />
            </Grid>
        </Box>
    );
} 